import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Box, TextField, Typography } from '@material-ui/core'
import { Controller, useForm } from 'react-hook-form'
import { BaseDialog, LoadingFeedback } from 'components'

import useSnackbar from 'hooks/useSnackbar'
import useFilter from 'hooks/useFilter'

import schema from './schema'
import theme from 'theme'
import * as service from 'service'

const DeleteGovernanceProjectDialog = ({
  open,
  setOpen,
  governanceProject,
  refresh,
}) => {
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()

  const { control, errors, handleSubmit } = useForm({
    validationSchema: schema,
    defaultValues: {
      reasonExclusion: '',
    },
  })

  const filter = useFilter()

  const handleClose = () => setOpen(false)

  const handleDelete = async (data) => {
    try {
      setLoading(true)

      await service.dponet.governanceProject.softDelete({
        governanceProjectId: governanceProject.id,
        reasonExclusion: data.reasonExclusion,
        ...data,
      })

      snackbar.open({
        message: 'Projeto deletado com sucesso.',
        variant: 'success',
      })

      handleClose()
      filter.setFilters({})
      refresh()
    } catch (error) {
      console.error(error)
      snackbar.open({
        message:
          error?.response?.data?.error?.message ||
          'Ocorreu um erro ao tentar deletar projeto. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={loading} />
      <BaseDialog
        open={open}
        setOpen={setOpen}
        title="Você tem certeza que deseja excluir esse projeto?"
        closeButtonText="Voltar"
        actionButtonText="Apagar"
        dialogSize="md"
        justifyActions="flex-end"
        formRef="deletar-projeto-de-governança"
        fullWidth
        noPadding
      >
        <Box
          p={2}
          display="flex"
          flexDirection="column"
          gridGap={theme.spacing(1)}
        >
          <Typography variant="subtitle1">
            Você está prestes a excluir o projeto de governança e todas as
            pendências associadas. Esta ação é irreversível. Você tem certeza
            que deseja continuar?
          </Typography>
          <form
            onSubmit={handleSubmit(handleDelete)}
            id="deletar-projeto-de-governança"
          >
            <Controller
              control={control}
              name="reasonExclusion"
              as={
                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  maxRows={5}
                  placeholder="Motivo da exclusão"
                  error={!!errors?.reasonExclusion}
                  helperText={errors?.reasonExclusion?.message}
                />
              }
            />
          </form>
        </Box>
      </BaseDialog>
    </>
  )
}

DeleteGovernanceProjectDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  governanceProject: PropTypes.object,
  refresh: PropTypes.func,
}

export default DeleteGovernanceProjectDialog
